import axios from 'axios';
import MitReservationService from '../../base/services/BaseMitReserveService.js';

class MitReservationSetupService {
    constructor() {
    }

    getReservationsNeedingSetup(paging, options){
        return new Promise ((resolve, reject) => {
            let url = new URL(window.location.origin+'/api/v1/manager/reservations/setup');

            for (let prop in options) {
                if (options.hasOwnProperty(prop)) {
                    if(prop === 'userRole'){
                        options[prop] = this.ACCESS_ROLES[options[prop].toUpperCase()];
                    }
                url.searchParams.append(prop, options[prop]);
                }
            }
            for (let prop in paging) {
                if (paging.hasOwnProperty(prop)) {
                url.searchParams.append(prop, paging[prop]);
                }
            }

            axios.get(url.pathname+url.search)
            .then((response) => {
                
                for(let x = 0; x < response.data.reservations.length; x++){
                    response.data.reservations[x] = MitReservationService.convertAPIToUI(response.data.reservations[x]);
                }

                return resolve(response.data);
            })
            .catch((error) => {
                console.log('ERROR:', error);
                return reject(error);
            });
        });
    }

    updateReservationSetupStatus(uniqueId, state){
        return new Promise ((resolve, reject) => {
            axios.post('/api/v1/manager/reservations/'+uniqueId+'/setup/state/'+state)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                console.log('ERROR:', error);
                return reject(error);
            });
        });
    }

    sendUpdateRequestToTIG(uniqueId){
        return new Promise ((resolve, reject) => {
            axios.post('/api/v1/manager/reservations/'+uniqueId+'/email/rtqueue')
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                console.log('ERROR:', error);
                return reject(error);
            });
        });
    }




}
export default new MitReservationSetupService();
